

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"viewBox":"0 0 20 20"}, rest), ["\n  ", h('path', {"fill":"currentColor","fill-rule":"nonzero","d":"m11.907.613.154.117L18.3 5.717c.836.673 1.367 1.985 1.264 3.076l-.023.18-.558 3.348a.675.675 0 0 1-1.34-.13l.009-.092.557-3.346c.098-.6-.206-1.455-.655-1.895l-.099-.088-6.238-4.987c-.673-.54-1.78-.575-2.5-.103l-.13.095L2.35 6.77c-.475.378-.817 1.215-.77 1.847l.016.133 1.197 7.162c.154.908 1.016 1.674 1.933 1.745l.138.006h10.08c.957 0 1.91-.806 2.07-1.751a.675.675 0 1 1 1.331.226c-.261 1.537-1.679 2.783-3.229 2.87l-.172.005H4.863c-1.568 0-3.023-1.184-3.368-2.706l-.034-.171-1.196-7.16C.08 7.911.558 6.575 1.369 5.834l.138-.118L7.743.72c1.153-.924 2.954-.96 4.164-.108ZM9.903 11.535c.342 0 .624.254.67.583l.005.092v2.7A.675.675 0 0 1 9.234 15l-.006-.091v-2.7c0-.373.303-.675.675-.675Z"}, []), "\n"]);
};

        